import React from 'react';
import { useTranslation } from 'react-i18next';

const PostInformationForm = ({ title, content, onChange, disabled }) => {
  const { t } = useTranslation();
  const inputStyle =
    'w-full bg-neutral-50 dark:bg-neutral-800 border border-neutral-300 dark:border-neutral-600 rounded-lg px-4 py-2 shadow-sm focus:border-primary focus:ring-2 focus:ring-primary/50 transition';

  return (
    <div className="flex flex-col gap-4">
      <div>
        <label
          htmlFor="title"
          className="block font-semibold mb-2 text-neutral-800 dark:text-neutral-200"
        >
          {t('posts.create_modal.information_form.title_label')}{' '}
          <span className="text-red-500">*</span>
        </label>
        <input
          type="text"
          id="title"
          name="title"
          value={title}
          onChange={onChange}
          className={inputStyle}
          placeholder={t(
            'posts.create_modal.information_form.title_placeholder'
          )}
          required
          disabled={disabled}
        />
      </div>
      <div>
        <label
          htmlFor="content"
          className="block font-semibold mb-2 text-neutral-800 dark:text-neutral-200"
        >
          {t('posts.create_modal.information_form.content_label')}
        </label>
        <textarea
          id="content"
          name="content"
          value={content}
          onChange={onChange}
          className={`${inputStyle} resize-y`}
          placeholder={t(
            'posts.create_modal.information_form.content_placeholder'
          )}
          rows="5"
          disabled={disabled}
        />
      </div>
    </div>
  );
};

export default PostInformationForm;
